<template>
    <div class="block-editor google-play-reply-review">
        <section>
            <div class="title">{{ $t('auto.googlePlayReplyReviewChannelId') }}</div>
            <TiptapEditor placeholder="Google Play Channel ID" :show-attributes="true" v-model="clone.channelId" automation-mode />
            <small>{{ $t('auto.googlePlayReplyReviewYanTVerilecekYorumunBulunduUKanalIdsi') }}</small>
        </section>
        <section>
            <div class="title">{{ $t('auto.googlePlayReplyReviewReviewId') }}</div>
            <TiptapEditor placeholder="Google Play Review ID" :show-attributes="true" v-model="clone.reviewId" automation-mode />
            <small>{{ $t('auto.googlePlayReplyReviewYanTVerilecekYorumunIdsi') }}</small>
        </section>
        <section>
            <div class="title">{{ $t('auto.googlePlayReplyReviewYanTMetni') }}</div>
            <TiptapEditor placeholder="Yanıt metni giriniz... (max 350 karakter)" :show-attributes="true" v-model="clone.text" automation-mode />
            <small class="char-limit" :class="{ exceeded: textLength > 350 }">
                {{ textLength }} / 350 karakter
            </small>
        </section>
    </div>
</template>

<script>
import _ from "lodash";
import TiptapEditor from "../../../../Chatbot/pages/dashboard/common/TiptapEditor.vue";
export default {
    name: "GooglePlayReplyReview",
    components: {
        TiptapEditor,
    },
    props: ["value"],
    data() {
        return {
            clone: _.cloneDeep({
                channelId: "",
                reviewId: "",
                text: "",
                ...this.value
            }),
        };
    },
    computed: {
        textLength() {
            const text = this.clone.text || "";
            // HTML tag'lerini kaldır
            const plainText = text.replace(/<[^>]*>/g, "");
            return plainText.length;
        },
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
    },
};
</script>

<style lang="scss" scoped>
.google-play-reply-review {
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 10px;

    section {
        margin-bottom: 20px;
    }

    .title {
        font-weight: bold;
        margin-bottom: 5px;
    }

    small {
        color: #777;
    }

    .char-limit {
        display: block;
        margin-top: 5px;
        
        &.exceeded {
            color: #ff4d4f;
            font-weight: bold;
        }
    }
}
</style>
